export const SUBSCRIPTION_CITY = 'SUBSCRIPTION_CITY';
export const SUBSCRIPTION_THEATER = 'SUBSCRIPTION_THEATER';
export const SUBSCRIPTION_RECHARGE = 'SUBSCRIPTION_RECHARGE';
export const SUBSCRIPTION_PRICE_RECHARGE = 'SUBSCRIPTION_PRICE_RECHARGE';
export const SUBSCRIPTION_TOTAL = 'SUBSCRIPTION_TOTAL';
export const SUBSCRIPTION_THEATERS = 'SUBSCRIPTION_THEATERS';
export const SUBSCRIPTION_TERMS = 'SUBSCRIPTION_TERMS';
